import { service } from '../axios';
/** 获取在线实验室列表 */
export function getOnlineLabs() {
    return service({
        url: '/labClient/onlineLabs',
        method: 'get'
    });
}
/** 根据实验室ID获取该实验室的设备列表（在线设备排前） */
export function getDevicesByLab(labLocationId) {
    return service({
        url: '/labClient/devicesByLab',
        method: 'get',
        params: { labLocationId }
    });
}
export function getCertificatesByUid(uid) {
    return service({
        url: '/labClient/getCertificatesByUid',
        method: 'get',
        params: { uid }
    });
}
export function detectLabByMac(macAddress) {
    return service({
        url: '/labClient/detectLabByMac',
        method: 'get',
        params: { macAddress }
    });
}
export function bindDeviceToLab(data) {
    return service({
        url: '/labClient/bindDeviceToLab',
        method: 'post',
        data
    });
}
export function getSessionLogsPage(params) {
    return service({
        url: '/labClient/getSessionLogsPage',
        method: 'get',
        params
    });
}
export function getMonitorStatistics(params) {
    return service({
        url: '/labClient/getMonitorStatistics',
        method: 'get',
        params
    });
}
export function deleteLabDeviceStatus(mac) {
    return service({
        url: '/labClient/deleteLabDeviceStatus',
        method: 'post',
        data: { mac }
    });
}
export function getClientAdminPWD(params) {
    return service({
        url: '/labClient/getClientAdminPWD',
        method: 'get',
        params
    });
}
export function getClientPWD(params) {
    return service({
        url: '/labClient/getClientPWD',
        method: 'get',
        params
    });
}
